var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (alerts, isForVNext, popUpText) {pug_html = pug_html + "\u003Cdiv class=\"gridPopup type5\" id=\"alertPopUp\"\u003E\u003Cdiv class=\"gridPopup-body\" id=\"popupbody\"\u003E\u003Cdiv class=\"gridPopup-outerBox\" id=\"outergrid\"\u003E";
if (!isForVNext) {
pug_html = pug_html + "\u003Cdiv class=\"gridPopup-close\"\u003E\u003Cdiv" + (" class=\"closeimage spritedimage spritedimagealign clickable\""+" role=\"button\" tabindex=\"0\""+pug.attr("aria-label", popUpText.remove, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
// iterate alerts
;(function(){
  var $$obj = alerts;
  if ('number' == typeof $$obj.length) {
      for (var alertIndex = 0, $$l = $$obj.length; alertIndex < $$l; alertIndex++) {
        var alert = $$obj[alertIndex];
pug_html = pug_html + "\u003Cdiv class=\"alert-error-row\"\u003E";
if (isForVNext) {
pug_html = pug_html + "\u003Cdiv class=\"status-error alert-popup-icon iconba iconba-ErrorBadge\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup-icon status_error alert-popup__status-icon\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__row\"\u003E\u003Cdiv class=\"alert-popup__heading\"\u003E" + (pug.escape(null == (pug_interp = alert.category) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = alert.description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate alert.causes
;(function(){
  var $$obj = alert.causes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var cause = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = cause) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var cause = $$obj[pug_index1];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = cause) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"link\"\u003E";
if (alert.action) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", alert.action.url, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = alert.action.linkText) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
if (alert.learnMore) {
if (alert.action) {
pug_html = pug_html + "\u003Cspan\u003E |\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E\u003Ca" + (" class=\"HelpTopic\""+" href=\"javascript:void(0)\""+pug.attr("query", alert.learnMore, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = popUpText.learnMore) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (alertIndex < alerts.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__separator\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var alertIndex in $$obj) {
      $$l++;
      var alert = $$obj[alertIndex];
pug_html = pug_html + "\u003Cdiv class=\"alert-error-row\"\u003E";
if (isForVNext) {
pug_html = pug_html + "\u003Cdiv class=\"status-error alert-popup-icon iconba iconba-ErrorBadge\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup-icon status_error alert-popup__status-icon\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__row\"\u003E\u003Cdiv class=\"alert-popup__heading\"\u003E" + (pug.escape(null == (pug_interp = alert.category) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = alert.description) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate alert.causes
;(function(){
  var $$obj = alert.causes;
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var cause = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = cause) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var cause = $$obj[pug_index2];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = cause) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"link\"\u003E";
if (alert.action) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", alert.action.url, true, true)+" target=\"_blank\"") + "\u003E" + (pug.escape(null == (pug_interp = alert.action.linkText) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
if (alert.learnMore) {
if (alert.action) {
pug_html = pug_html + "\u003Cspan\u003E |\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cspan\u003E\u003Ca" + (" class=\"HelpTopic\""+" href=\"javascript:void(0)\""+pug.attr("query", alert.learnMore, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = popUpText.learnMore) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (alertIndex < alerts.length - 1) {
pug_html = pug_html + "\u003Cdiv class=\"alert-popup__separator\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"alerts" in locals_for_with?locals_for_with.alerts:typeof alerts!=="undefined"?alerts:undefined,"isForVNext" in locals_for_with?locals_for_with.isForVNext:typeof isForVNext!=="undefined"?isForVNext:undefined,"popUpText" in locals_for_with?locals_for_with.popUpText:typeof popUpText!=="undefined"?popUpText:undefined));;return pug_html;};
module.exports = template;